import {Button, FormControl} from 'platform/components';

import {useWatch} from 'react-hook-form';

import i18n from '@dms/i18n';

import {RequiredTestIdProps} from 'shared/web';

import {CreateSupplierOrdersFormValues} from './createSupplierOrdersFormSchema';

interface SelectAllWarehousesButtonProps extends RequiredTestIdProps {
  control: FormControl<CreateSupplierOrdersFormValues>;
  onToggle: (isSelected: boolean) => void;
}

export function SelectAllWarehousesButton(props: SelectAllWarehousesButtonProps) {
  const warehouses = useWatch({control: props.control, name: 'warehouses'});
  const isAllSelected = warehouses.every((warehouse) => warehouse.isSelected);

  return (
    <Button
      variant="link"
      size="small"
      leftIcon="action/done_all"
      title={i18n.t(isAllSelected ? 'general.actions.unselectAll' : 'general.actions.selectAll')}
      onClick={() => props.onToggle(!isAllSelected)}
      data-testid={props['data-testid']}
    />
  );
}
